import { render, staticRenderFns } from "./InvalidResetPassword.vue?vue&type=template&id=0c1e55f5&"
import script from "./InvalidResetPassword.vue?vue&type=script&lang=js&"
export * from "./InvalidResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./InvalidResetPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports